// @flow

import { observable, computed, action, configure, runInAction } from 'mobx';
import userApi from 'api/users.api';

configure({ enforceActions: 'observed' });

class SessionStore {
  @observable currentUser = null;

  @computed
  get firstName() {
    if (!this.currentUser) return '';
    return this.currentUser.fullName.split(' ')[0];
  }

  @action.bound
  async getCurrentUser() {
    const result = await userApi.fetchCurrentUser();

    runInAction(() => {
      this.currentUser = result;
    });
  }
}

export default new SessionStore();
